import notoSansScFontUrl from "../../fonts/NotoSansSC-Regular.ttf";

const CJK_OR_FULLWIDTH_REGEX =
  /[\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\u3000-\u303f\uff00-\uffef]/;
const CJK_FONT_NAME = "NotoSansSC";
const CJK_FONT_FILE = "NotoSansSC-Regular.ttf";

const bytesToBase64 = (bytes) => {
  const chunkSize = 0x8000;
  let binary = "";

  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk = bytes.subarray(i, i + chunkSize);
    binary += String.fromCharCode.apply(null, chunk);
  }

  return btoa(binary);
};

const loadFontBase64Sync = (fontUrl) => {
  if (!fontUrl || typeof XMLHttpRequest === "undefined") return null;

  try {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", fontUrl, false);
    xhr.overrideMimeType("text/plain; charset=x-user-defined");
    xhr.send(null);

    if (xhr.status >= 200 && xhr.status < 300 && xhr.responseText) {
      const binaryText = xhr.responseText;
      const bytes = new Uint8Array(binaryText.length);
      for (let i = 0; i < binaryText.length; i += 1) {
        bytes[i] = binaryText.charCodeAt(i) & 0xff;
      }
      return bytesToBase64(bytes);
    }
  } catch (error) {
    console.warn("Failed to load Chinese font:", error);
  }

  return null;
};

const registerChineseFontIfNeeded = (doc) => {
  if (!doc?.getFontList) return false;

  const fontList = doc.getFontList() || {};
  if (fontList[CJK_FONT_NAME]) return true;

  const base64 = loadFontBase64Sync(notoSansScFontUrl);
  if (!base64 || !doc.addFileToVFS || !doc.addFont) return false;

  try {
    doc.addFileToVFS(CJK_FONT_FILE, base64);
    doc.addFont(CJK_FONT_FILE, CJK_FONT_NAME, "normal");
    doc.addFont(CJK_FONT_FILE, CJK_FONT_NAME, "bold");
    doc.addFont(CJK_FONT_FILE, CJK_FONT_NAME, "italic");
    doc.addFont(CJK_FONT_FILE, CJK_FONT_NAME, "bolditalic");
    return true;
  } catch (error) {
    console.warn("Failed to register Chinese font:", error);
    return false;
  }
};

export const hasCjkOrFullWidthText = (value) => {
  const content = Array.isArray(value) ? value.join("") : String(value || "");
  return CJK_OR_FULLWIDTH_REGEX.test(content);
};

export const resolvePdfFontName = (
  doc,
  text,
  defaultFont = "helvetica",
  cjkFont = CJK_FONT_NAME
) => {
  if (!hasCjkOrFullWidthText(text)) return defaultFont;

  registerChineseFontIfNeeded(doc);
  const fontList = doc?.getFontList?.() || {};
  return fontList[cjkFont] ? cjkFont : defaultFont;
};

export const applyChineseFontToCellIfNeeded = (pdf, cellData) => {
  const text = cellData?.cell?.raw?.content ?? cellData?.cell?.text;
  const fontName = resolvePdfFontName(pdf?.doc, text);
  if (fontName === CJK_FONT_NAME) {
    cellData.cell.styles.font = CJK_FONT_NAME;
  }
};
